


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Topic from '../../components/topic.vue'
let favorites: any[] = [];

@Component({ components: { Topic } })
export default class Practice extends Vue {
    @Prop()
    private libraryId !: number;
    @Prop()
    private chapterId !: number;

    private loading = false;

    private title = "练习设置";

    private testForm = {
        isSingle: true,
        isMultiple: true,
        isJudge: true,
        singleRange: [1, 1],
        multipleRange: [1, 1],
        judgeRange: [1, 1],
        isTopicRandom: false,
        isOptionsRandom: false,
        onlyFavorite: false
    }
    private topics: any[] = [];
    private index = 1;
    private singleMax = 0;
    private multipleMax = 0;
    private judgeMax = 0;
    private favorite: any = null;

    created() {
        this.singleMax = this.$store.state.topic.singleCount;
        this.multipleMax = this.$store.state.topic.multipleCount;
        this.judgeMax = this.$store.state.topic.judgeCount;
        this.testForm.singleRange[1] = this.singleMax;
        this.testForm.multipleRange[1] = this.multipleMax;
        this.testForm.judgeRange[1] = this.judgeMax;
    }

    destroyed() {
        // 同步收藏
        this.$apis.postFavorites(this.libraryId, this.chapterId, favorites);
    }

    onBegin() {
        this.$apis.postPractice(this.libraryId, this.chapterId, this.testForm)
            .then((res: any) => {
                this.topics = res.data;
                this.title = this.testForm.isTopicRandom ? "随机出题" : "顺序出题"
            });
    }

    onShowAnswer() {
        (this.$refs.topic as any).show(false);
    }

    onPrev() {
        if (this.index > 1) {
            this.index--;
        }
    }

    onMouseDown(e: any) {
        if (e.button === 4)
            this.onNext();
    }

    onNext() {
        if (this.index < this.topics.length) {
            this.index++;
        }
    }

    onChange(value: number) {
        this.index = value;
    }

    onFav() {
        let cur = this.topics[this.index - 1];
        cur.isMark = !cur.isMark;

        var res = favorites.find((item, index) => {
            return item.id == cur.id;
        });
        if (res)
            res.isMark = cur.isMark;
        else
            favorites.push({ id: cur.id, isMark: cur.isMark });
    }
}

